<template>
  <div class="package-price-info">
    <table>
      <tbody>
        <tr class="package-total">
          <td class="package-price-header">
            <p>
              {{ $t("formPackage.subtotal") }}
            </p>
          </td>
          <td class="amount">
            <p>
              <currency-convert
                :amount="packageTotal"
                :currency="currency"
              />
            </p>
          </td>
        </tr>
        <tr class="processing-fee-wrapper">
          <td class="processing-fee-header">
            <p>
              {{ $t("formPackage.processingFee") }}
              <span class="fee-info-icon">
                <i
                  class="fa fa-info-circle"
                  aria-hidden="true"
                />
                <span class="fee-info">
                  {{ $t("formPackage.processingFeeInfo") }}
                </span>
              </span>
            </p>
          </td>
          <td class="amount">
            <p>
              <currency-convert
                :amount="processingFee"
                :currency="currency"
              />
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { CurrencyConvert } from '../../../default/currency_convert'

export default {
  name: 'PackageTotal',
  components: {
    CurrencyConvert
  },
  props: {
    packageTotal: {
      type: [Number, String],
      required: true
    },
    processingFee: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    order(){
      return this.$store.state.order.order
    },

    currency(){
      if(this.order){
        return this.order.currency
      }else {
        return 'USD'
      }
    },
  }
}
</script>